import React from "react";

export default function SQLServer_RADIANS() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_RADIANS</h1>
      <p>This is the SQLServer_RADIANS component generated from the SQL JSON.</p>
    </div>
  );
}
